var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('hosts-filter',{on:{"changeQuery":_vm.changeQuery}}),_c('hosts-table',{attrs:{"commonQuery":_vm.commonQuery},on:{"changeQuery":_vm.changeQuery}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }